import { useEffect, useState } from 'react';
import { getMultiBonus } from 'services/api/slipService';
import { MultiBonusRules } from 'utils/multiBonus';

// One copy for every slip on the page, asked again every few minutes so a
// switch in the admin reaches open apps.
const REFRESH_MS = 5 * 60_000;
let cached: MultiBonusRules = { enabled: false };
let fetchedAt = 0;
let pending: Promise<MultiBonusRules> | null = null;

const load = () => {
  if (!pending) {
    pending = getMultiBonus().then((r) => {
      cached = r;
      fetchedAt = Date.now();
      pending = null;
      return r;
    });
  }
  return pending;
};

/** The bonus on the number of matches, for the slip. */
export const useMultiBonus = () => {
  const [rules, setRules] = useState<MultiBonusRules>(cached);
  useEffect(() => {
    let alive = true;
    const refresh = () =>
      load().then((r) => {
        if (alive) setRules(r);
      });
    if (Date.now() - fetchedAt > REFRESH_MS) refresh();
    else setRules(cached);
    const id = window.setInterval(refresh, REFRESH_MS);
    return () => {
      alive = false;
      window.clearInterval(id);
    };
  }, []);
  return rules;
};
